<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="text-center">
        <h1>ASISTENCIAS EN PROCESO</h1>
      </v-col>
      <v-col v-for="(item, index) in dataAsistencias" :key="index">
        <v-card max-width="500">
          <v-img
            v-if="dataAsistencias == 0"
            width="300"
            height="300"
            contain
            class="mx-auto"
            :src="require('@/assets/logo.jpg')"
          ></v-img>
          <v-list three-line>
            <template>

              <v-list-item :key="item.title">
                <v-list-item-content>
                  <v-list-item-title class="headline"
                    >Fecha: {{ item.fechaHoraActual }}</v-list-item-title
                  >
                  <v-list-item-subtitle class="headline"
                    >Póliza:{{ item.polizaBase }}</v-list-item-subtitle
                  >
                  <v-list-item-subtitle class="headline"
                    >Tipo de asistencia:{{
                      item.tipoAsistencia
                    }}</v-list-item-subtitle
                  >
                  <v-list-item-subtitle class="headline"
                    >País:{{
                      item.pais
                    }}</v-list-item-subtitle
                  >
                  <v-list-item-subtitle class="headline"
                    >Titular póliza:{{
                      item.titularpoliza
                    }}</v-list-item-subtitle
                  >
                  <v-list-item-subtitle class="headline"
                    >Placa:{{
                      item.placa
                    }}</v-list-item-subtitle
                  >
                  <v-list-item-subtitle class="headline"
                    >Marca:{{
                      item.marca
                    }}</v-list-item-subtitle
                  >
                  <v-list-item-subtitle class="headline"
                    >Modelo:{{
                      item.modelo
                    }}</v-list-item-subtitle
                  >
                  <v-list-item-subtitle class="headline"
                    >Color:{{
                      item.color
                    }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import ButtonScroll from "../components/ButtonScroll.vue";

import axios from "axios";

export default {
  name: "home",
  components: {
    Header,
    Footer,
    ButtonScroll,
  },
  data: () => ({
    dataAsistencias: [],
    localLengthAnt: 0,
  }),

  created() {
    let me = this;
    setInterval(() => {
      me.getAsistencias();
    }, 3000);
  },
  methods: {
    getAsistencias() {
      let me = this;
      axios
        .get("https://192.168.0.245:4445/api/Cabinas/listarAsistencias")
        .then((Response) => {
          var local = Response.data;
          var localLength = local.length;
          if (
            localLength > me.localLengthAnt ||
            localLength < me.localLengthAnt
          ) {
            me.dataAsistencias = [];
            local.forEach((Element, index) => {
              var fecha = Element.fechaHoraActual;
              var fechaHora = fecha.split("T");
              me.dataAsistencias.push({
                fechaHoraActual: fechaHora[0] + " " + fechaHora[1],
                polizaBase: Element.polizaBase,
                tipoAsistencia: Element.tipoAsistencia,
                pais: Element.pais,
                titularpoliza: Element.titularpoliza,
                placa: Element.placa,
                marca: Element.marca,
                modelo: Element.modelo,
                color: Element.color,
              });
            });
            me.localLengthAnt = localLength;
            //console.log("direfente tamaño");
          } else {
            //console.log("mismo tamaño");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
